enum Routes {
  TEAM = '/team',
  MATCHES = '/matches',
  VOUCHERS = '/vouchers',
}

export default Routes
